import axiosInstance from "./axiosInstance";
import logger from "../utils/logger";
import type { AiProcessingLog } from "../models/aiProcessingLog";

export const getAiProcessingLogs = async (workerId: string, limit = 100): Promise<AiProcessingLog[]> => {
    try {
        const response = await axiosInstance.get<AiProcessingLog[]>(`/ai-processing-logs/worker/${workerId}`, {
            params: { limit }
        });
        return response.data;
    } catch (error) {
        logger.error('Failed to fetch sanitized AI processing diagnostics', {
            errorType: error instanceof Error ? error.name : 'Error',
        });
        throw error;
    }
};
